define(function(require, exports, module) {
    var newprice = require('../newprice/newprice');
    var selfchlevent = {
        config: {
            offset: 1,
            num1210: 5
        },
        init: function() {
            var self = this;
            self.switchStore();
            self.changeItem();
            self.changeArea();
        },
        switchStore: function() {
            $(".addrSelect").on("click", function() {
                if ($(this).hasClass("active")) {
                    $(this).removeClass("active");
                } else {
                    $(this).addClass("active");
                }
            });

            $("body").on("click", function(event) {
                var $this = $(event.target);
                if ($this.hasClass("addrSelect") || $this.parent().hasClass("addrSelect")) {
                    return false;
                }

                $(".addrSelect").removeClass("active");
            });
        },
        changeItem: function() {
            var self = this;
            $("#cj-ssdz .change").on("click", function() {
                var sign = $("#sign").val();
                self.config.offset += self.config.num1210;
                $.ajax({
                    url: '/getTakeWayGoods.html',
                    data: {
                        "offset": self.config.offset,
                        "num": self.config.num1210,
                        "sign": sign
                    },
                    method: 'get',
                    dataType: 'jsonp',
                    success: function(data) {
                        var data = {"data": data};
                        var tpl = require("../../template/selfChangeItem");
                        var html = self.render(data, tpl);
                        
                        $("#cj-ssdz .content .items").html(html);
                        newprice.fn.init();
                    }
                });
            });
        },
        changeArea: function() {
            var self = this;
            $("#cj-jsqqg .addrList li").on("click", function() {
                var $this = $(this);
                var bondedAreaId = $this.attr("areaid");
                var sign = $("#sign").val();

                $.ajax({
                    url: '/getGoodsByBondedArea.html',
                    data: {
                        "bondedAreaId": bondedAreaId,
                        "sign": sign
                    },
                    method: 'get',
                    dataType: 'jsonp',
                    success: function(data) {
                        var moreUrl = data.linkText || "";
                        var bondedAreaText = data.bondedArea || "";
                        var dataObj = {"data": data};
                        var tpl = require("../../template/selfChangeArea");
                        var html = self.render(dataObj, tpl);
                        
                        $("#cj-jsqqg .content .items").html(html);
                        newprice.fn.init();

                        $this.parents(".addrSelect").find("span").text($this.text());

                        $("#cj-jsqqg .more").attr("href", moreUrl);
                        $("#cj-jsqqg .more").find("span").text(bondedAreaText);
                    }
                });
            });
        },
        render: function(data, tpl) {
            var render = template.compile(tpl.tpl);
            return render(data);
        }
    };
    exports.fn = selfchlevent;
});



// WEBPACK FOOTER //
// ./src/js/unit/selfchlevent/selfchlevent.js